import { Checkbox, Grid, Avatar, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

const getPastelColor = (text: string) => {
  let hash = 0;

  for (let i = 0; i < text?.length; i++) {
    hash = text?.charCodeAt(i) + ((hash << 5) - hash);
  }

  const h = hash % 360;
  const s = 60 + (hash % 20);
  const l = 75 + (hash % 10);

  return `hsl(${h}, ${s}%, ${l}%)`;
};

const getInitials = (name: string) => {
  if (!name) return '';

  const parts = name?.trim()?.split(' ')?.filter(Boolean);

  if (parts.length === 1) {
    return parts[0][0]?.toUpperCase();
  }

  return (parts[0][0] + parts[1][0])?.toUpperCase();
};

interface CustomCheckboxProps {
  name: string;
  label: string;
  email?: string;
  phone?: string;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
}

export const FormSingleCheckboxAvatar = ({
  name,
  label,
  email,
  phone,
  disabled,
  onChange: onChangeProp,
}: CustomCheckboxProps) => {
  const { control } = useFormContext();

  const stringAvatar = (name: string) => {
    return {
      sx: {
        bgcolor: getPastelColor(name),
        color: '#333',
      },
      children: getInitials(name),
    };
  }

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={false}
      render={({ field: { value, onChange, onBlur } }) => {
        const handleChange = (
          event: React.ChangeEvent<HTMLInputElement>,
          checked: boolean
        ) => {
          onChange(checked); // IMPORTANT: pass checked value
          if (onChangeProp) {
            onChangeProp(checked);
          }
        };

        return (
          <Grid
            container
            direction="row"
            alignItems="center"
            sx={{ cursor: 'pointer' }}
          >
            <Checkbox
              checked={!!value}
              onChange={handleChange}
              onBlur={onBlur}
              disabled={disabled}
            />

            <Avatar {...stringAvatar(label)} />

            <div style={{ paddingLeft: 5 }}>
              <Typography variant="body1">{label}</Typography>
              <Typography variant="caption" color="#737373">
                {[email, phone].filter(Boolean).join(' | ')}
              </Typography>
            </div>
          </Grid>
        );
      }}
    />
  );
};